import Vue from 'vue'

import Localized from '@/components/Localized.tsx'
import { checkCondition } from '@/utils'

export default Vue.extend({
  components: { Localized },
  computed: {
    translatedPlaceholder(): string | undefined {
      const placeholder = this.placeholder || {
        byLanguage: {
          ar: 'الرجاء الإختيار',
          de: 'Bitte wählen',
          en: 'Choose',
        },
      }

      if (typeof placeholder === 'string') {
        return placeholder
      } else {
        return placeholder!.byLanguage![this.$i18n.locale]
      }
    },
    firstEmptyRequiredVariable(): string | undefined {
      let parent = this.$parent
      let firstEmptyRequiredVariable: string | undefined

      while (parent !== this.$root && !firstEmptyRequiredVariable) {
        firstEmptyRequiredVariable = (parent as any).firstEmptyRequiredVariable
        parent = parent.$parent
      }

      return firstEmptyRequiredVariable
    },
    isDisabled(): boolean {
      return checkCondition(this.disabled, this.value)
    },
    isRequired(): boolean {
      return checkCondition(this.required, this.value)
    },
    isEmpty(): boolean {
      if (this.variable === undefined || this.value === undefined || this.value === null) {
        return false
      } else {
        const value = this.value[this.variable]
        return (
          value === undefined ||
          value === null ||
          (typeof value === 'string' && value.trim().length === 0)
        )
      }
    },
    isToBeCompleted(): boolean {
      return !this.isDisabled && !this.isSkipped && this.isRequired && this.isEmpty
    },
    isFirstToBeCompleted(): boolean {
      return this.isToBeCompleted && this.variable === this.firstEmptyRequiredVariable
    },
    isSkipped(): boolean {
      return checkCondition(this.skipped, this.value)
    },
    addedClasses(): string[] {
      if (this.css && this.css.addClasses) {
        return this.css.addClasses
      } else {
        return []
      }
    },
  },
  created() {
    if (!this.variable && !(this as any).scales && !(this as any).options) {
      throw new Error('provide either scales, options, or a variable property')
    }
    if (this.isToBeCompleted) {
      this.$emit('unready')
    } else {
      this.$emit('ready')
    }
  },
  props: {
    css: {
      type: Object,
    },
    disabled: {
      default: false,
      type: [Boolean, Object],
    },
    placeholder: {
      type: [String, Object],
    },
    prompt: {
      required: true,
      type: [String, Object],
    },
    required: {
      default: false,
      type: [Boolean, Object],
    },
    skipped: {
      default: false,
      type: [Boolean, Object],
    },
    value: {
      required: true,
      type: Object,
    },
    variable: {
      type: String,
    },
  },
  watch: {
    isToBeCompleted(newValue: boolean, oldValue: boolean) {
      if (newValue === oldValue) {
        return
      }
      if (newValue) {
        this.$emit('unready')
      } else {
        this.$emit('ready')
      }
    },
  },
})
